import { extractFirstNumber } from '@/shared/lib'
import { saveToLocalStorage } from '@/shared/localStorage/localStorageRepository'

export const setEtagToLocalStorage = (
    moviesCategoryID: string,
    maxAge: string,
    requestTime: number,
    eTag: string
) => {
    const dataAge = extractFirstNumber(maxAge) || 0

    saveToLocalStorage(
        moviesCategoryID.toString(),
        JSON.stringify({
            eTag,
            requestTime: requestTime + Number(dataAge * 1000),
        })
    )
}
